module.exports = __webpack_public_path__ + "img/austin_jackson.3931596f.png";